import IconBox from "./icons/IconBoxComponent";

export default {
    IconBox
};